import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";
function Details({ details, setDetails }) {
  const exports = useRef();

  // eslint-disable-next-line no-unused-vars
  const change = useReactToPrint({
    content: () => exports.current,
    documentTitle: "user List",
    onAfterPrint: () => alert("Data Saved"),
  });
  return (
    <div
      className={`${
        !details && "hidden"
      } fixed inset-0 overflow-scroll z-50 flex items-center justify-center bg-black bg-opacity-25 px-4 sm:px-6 lg:px-8`}
    >
      <div className="p-8 rounded-xl bg-white shadow w-full max-w-4xl mx-auto">
        <div ref={exports} className="w-full">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-center">
            <div className="relative">
              <div className="w-32 h-32 bg-white mx-auto rounded-full shadow-2xl flex items-center justify-center">
                <img
                  src="./image/1 png.png"
                  className="w-28 h-28 rounded-full"
                  alt="profile"
                />
              </div>
            </div>
          </div>
          <div className="mt-10 text-center border-b pb-6">
            <h1 className="text-3xl font-semibold text-gray-700">
              Organization Overview:
            </h1>
            <p className="mt-6 text-gray-500 text-sm sm:text-base">
              Meklit Humanitarian Association (MHA) was created with the goal of
              "boosting the economic capacity of Orthodox youth".
            </p>
            <p className="mt-4 text-gray-500 text-sm sm:text-base">
              The EOTC actively engages its members through consistent service
              traditions and practical spirituality. Recently, the church has
              faced serious challenges that put a constraint on its performance
              as a spiritual organization.
            </p>
            <p className="mt-4 text-gray-500 text-sm sm:text-base">
              As the largest church in Ethiopia, the Ethiopian Orthodox Tewahedo
              Church sustains many members that live under the poverty line.
              These youth, as members of the country’s larger population, face
              economic and political challenges, the most concerning being
              unemployment.
            </p>
            <p className="mt-4 text-gray-500 text-sm sm:text-base">
              Youth of the Ethiopian Orthodox Church share common values and a
              special sense of unity. Our organization, Meklit Humanitarian
              Association, seeks to empower this unity to solve the church’s and
              the country’s larger issues.
            </p>
          </div>
        </div>
        <div className="flex justify-center gap-4 mt-6">
          <button
            className="text-white py-2 px-4 rounded bg-gray-700 hover:bg-gray-800 shadow hover:shadow-lg font-medium transition transform hover:-translate-y-0.5"
            onClick={() => setDetails((prev) => !prev)}
          >
            Back
          </button>
          <button
            className="text-white py-2 px-4 rounded bg-blue-400 hover:bg-blue-500 shadow hover:shadow-lg font-medium transition transform hover:-translate-y-0.5"
            onClick={() => setDetails((prev) => !prev)}
          >
            Finish
          </button>
        </div>
      </div>
    </div>
  );
}

export default Details;
